import React from 'react';
import HeroSection from '../components/HeroSection';
import DemoSection from '../components/DemoSection';
import Footer from '../components/Footer';

export default function LandingPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <HeroSection />
      <DemoSection />
      <Footer />
    </div>
  );
}